import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import { chargersRanked as chargersRankedAction } from 'actions';
import { byIdShape } from 'utils/propTypes';

import PageHeader from 'AppComponents/PageHeader';

import Charger from './Charger';

import './styles.scss';


class Ranking extends Component {

  static propTypes = {
    chargersById: byIdShape.isRequired,
    chargersRanked: PropTypes.arrayOf(PropTypes.number),
    chargersRankedRequest: PropTypes.func.isRequired,
  };

  static defaultProps = {
    chargersRanked: [],
  };

  componentDidMount() {
    this.props.chargersRankedRequest();
  }

  render() {
    const { chargersRanked, chargersById } = this.props;
    return (
      <div className='container'>

        <Helmet title='Charger Rankings' />

        <PageHeader title='Charger Rankings' />

        <ol styleName='rankings-list'>
          { chargersRanked ? chargersRanked.map((pk) => {
            const charger = chargersById[pk];
            return <Charger key={charger.pk} charger={charger} numRanked={chargersRanked.length} />;
          }) : null }
        </ol>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  chargersRanked: state.chargers.ranked,
  chargersById: state.chargers.byId,
});

const chargersRankedRequest = chargersRankedAction.request;

export default connect(
  mapStateToProps, {
    chargersRankedRequest,
  })(Ranking);



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Ranking/index.jsx